import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=122e9580&scoped=true&"
import script from "./TitleBar.vue?vue&type=script&lang=ts&"
export * from "./TitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=122e9580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e9580",
  null
  
)

export default component.exports